import { register } from "@shopify/theme-sections";
import Swiper, { Navigation, Pagination } from "swiper";

Swiper.use([Navigation, Pagination]);

const selectors = {
	sliderContainer: ".js-slider-container",
	arrowNext: ".js-slider-arrow-next",
	arrowPrev: ".js-slider-arrow-prev",
	pagination: ".js-slider-pagination"
};

const datasets = {
	customOptions: "customOptions"
};

const modifiers = {
	initialized: "initialized"
};

register("slider", {
	onLoad: function () {
		this.initSlider();
	},
	initSlider() {
		this.sliderContainer = this.container.querySelector(
			selectors.sliderContainer
		);

		if (!this.sliderContainer) {
			return null;
		}

		let customOptions = this.container.dataset[datasets.customOptions];

		if (customOptions) {
			customOptions = JSON.parse(customOptions);
		}

		this.options = {
			slidesPerView: 1,
			spaceBetween: 0,
			navigation: {
				nextEl: selectors.arrowNext,
				prevEl: selectors.arrowPrev
			},
			breakpoints: {
				640: {
					slidesPerView: 1.5,
					spaceBetween: 40
				},
				998: {
					slidesPerView: 2.3,
					spaceBetween: 40
				}
			},
			pagination: {
				el: selectors.pagination,
				type: "bullets"
			},
			on: {
				afterInit: () => {
					this.sliderContainer.classList.add(modifiers.initialized);
				}
			},
			...customOptions
		};

		this.slider = new Swiper(this.sliderContainer, this.options);
	},
	onUnload: function () {
		if (!this.slider) {
			return false;
		}

		this.slider.destroy();
	}
});
